export const RETENTION_FLOOR_DAYS = 90;

export const RETENTION_CEILING_DAYS = 36_500;

export const SQUASH_AFTER_DAYS = 730;

export const AUDIT_LOG_DAYS = 365;

export const GUILD_PURGE_GRACE_MS = 90 * 86_400_000;
